var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9025 42.8483C64.0027 43.9499 64.6207 45.4431 64.6207 47C64.6207 48.5569 64.0027 50.0501 62.9025 51.1516L40.7498 73.3121C39.6477 74.4138 38.1531 75.0324 36.5948 75.0321C35.0365 75.0317 33.5422 74.4123 32.4406 73.3102C31.339 72.2081 30.7203 70.7135 30.7207 69.1552C30.7211 67.5969 31.3404 66.1026 32.4426 65.001L50.4436 47L32.4426 28.999C31.3719 27.8914 30.779 26.4077 30.7916 24.8673C30.8043 23.3268 31.4215 21.853 32.5102 20.7632C33.599 19.6734 35.0722 19.0549 36.6126 19.0408C38.153 19.0267 39.6374 19.6181 40.7459 20.6878L62.9064 42.8444L62.9025 42.8483Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSelect);
export default __webpack_public_path__ + "static/media/rightSelect.746284736c882d81cdc49e142894dc45.svg";
export { ForwardRef as ReactComponent };